import React from "react";

export default function TACnPP({ paddingBottom = 50 }) {
  return (
    <div
      style={{
        paddingBottom,
      }}
    >
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '@import url(\'https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUXza5VhXqVC6o75Eld_V98\');.lst-kix_list_2-1>li{counter-increment:lst-ctn-kix_list_2-1}.lst-kix_list_5-0>li{counter-increment:lst-ctn-kix_list_5-0}ol.lst-kix_list_2-3.start{counter-reset:lst-ctn-kix_list_2-3 0}ol.lst-kix_cqy89pbleymu-2.start{counter-reset:lst-ctn-kix_cqy89pbleymu-2 0}.lst-kix_puk3iz2l9na6-7>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-7}ol.lst-kix_list_1-5.start{counter-reset:lst-ctn-kix_list_1-5 0}ol.lst-kix_cqy89pbleymu-5{list-style-type:none}ol.lst-kix_cqy89pbleymu-6{list-style-type:none}.lst-kix_bnzmjmjaf2k3-7>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-7}ol.lst-kix_cqy89pbleymu-7{list-style-type:none}ol.lst-kix_list_5-3.start{counter-reset:lst-ctn-kix_list_5-3 0}ol.lst-kix_cqy89pbleymu-8{list-style-type:none}.lst-kix_list_2-3>li{counter-increment:lst-ctn-kix_list_2-3}ol.lst-kix_cqy89pbleymu-1{list-style-type:none}ol.lst-kix_cqy89pbleymu-2{list-style-type:none}ol.lst-kix_cqy89pbleymu-3{list-style-type:none}ol.lst-kix_cqy89pbleymu-4{list-style-type:none}ol.lst-kix_cqy89pbleymu-0{list-style-type:none}.lst-kix_puk3iz2l9na6-5>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-5}.lst-kix_list_1-2>li{counter-increment:lst-ctn-kix_list_1-2}.lst-kix_cqy89pbleymu-7>li{counter-increment:lst-ctn-kix_cqy89pbleymu-7}.lst-kix_list_5-2>li{counter-increment:lst-ctn-kix_list_5-2}.lst-kix_list_5-0>li:before{content:"" counter(lst-ctn-kix_list_5-0,decimal) ". "}.lst-kix_list_5-4>li{counter-increment:lst-ctn-kix_list_5-4}.lst-kix_list_1-4>li{counter-increment:lst-ctn-kix_list_1-4}ol.lst-kix_list_1-6.start{counter-reset:lst-ctn-kix_list_1-6 0}.lst-kix_list_5-3>li:before{content:"" counter(lst-ctn-kix_list_5-3,decimal) ". "}.lst-kix_list_5-2>li:before{content:"" counter(lst-ctn-kix_list_5-2,lower-roman) ". "}.lst-kix_list_5-1>li:before{content:"" counter(lst-ctn-kix_list_5-1,lower-latin) ". "}.lst-kix_puk3iz2l9na6-3>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-3}li.li-bullet-6:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}.lst-kix_list_5-7>li:before{content:"" counter(lst-ctn-kix_list_5-7,lower-latin) ". "}.lst-kix_list_5-6>li:before{content:"" counter(lst-ctn-kix_list_5-6,decimal) ". "}.lst-kix_list_5-8>li:before{content:"" counter(lst-ctn-kix_list_5-8,lower-roman) ". "}li.li-bullet-13:before{margin-left:-20.4pt;white-space:nowrap;display:inline-block;min-width:20.4pt}.lst-kix_list_5-4>li:before{content:"" counter(lst-ctn-kix_list_5-4,lower-latin) ". "}.lst-kix_cqy89pbleymu-5>li{counter-increment:lst-ctn-kix_cqy89pbleymu-5}.lst-kix_list_5-5>li:before{content:"" counter(lst-ctn-kix_list_5-5,lower-roman) ". "}ol.lst-kix_list_1-0.start{counter-reset:lst-ctn-kix_list_1-0 0}ol.lst-kix_list_4-0.start{counter-reset:lst-ctn-kix_list_4-0 0}li.li-bullet-2:before{margin-left:-25.2pt;white-space:nowrap;display:inline-block;min-width:25.2pt}.lst-kix_list_2-5>li{counter-increment:lst-ctn-kix_list_2-5}.lst-kix_list_2-8>li{counter-increment:lst-ctn-kix_list_2-8}.lst-kix_bnzmjmjaf2k3-0>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-0}ol.lst-kix_list_2-4.start{counter-reset:lst-ctn-kix_list_2-4 0}.lst-kix_bnzmjmjaf2k3-2>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-1,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-2,decimal) ". "}ol.lst-kix_list_1-3{list-style-type:none}ol.lst-kix_list_1-4{list-style-type:none}.lst-kix_list_2-7>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) "." counter(lst-ctn-kix_list_2-7,decimal) ". "}.lst-kix_list_2-7>li{counter-increment:lst-ctn-kix_list_2-7}.lst-kix_cqy89pbleymu-3>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-3,decimal) ". "}ol.lst-kix_cqy89pbleymu-6.start{counter-reset:lst-ctn-kix_cqy89pbleymu-6 0}ol.lst-kix_list_1-5{list-style-type:none}ol.lst-kix_list_1-6{list-style-type:none}.lst-kix_bnzmjmjaf2k3-0>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) ". "}.lst-kix_bnzmjmjaf2k3-4>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-1,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-2,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-3,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-4,decimal) ". "}ol.lst-kix_list_1-0{list-style-type:none}.lst-kix_list_2-5>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) ". "}.lst-kix_cqy89pbleymu-6>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-6,decimal) ". "}ol.lst-kix_list_1-1{list-style-type:none}ol.lst-kix_list_1-2{list-style-type:none}.lst-kix_bnzmjmjaf2k3-6>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-1,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-2,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-3,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-4,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-5,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-6,decimal) ". "}.lst-kix_cqy89pbleymu-8>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-8,lower-roman) ". "}.lst-kix_puk3iz2l9na6-0>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-0}.lst-kix_cqy89pbleymu-1>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-1,lower-latin) ". "}ol.lst-kix_bnzmjmjaf2k3-7.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-7 0}ol.lst-kix_puk3iz2l9na6-0.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-0 1}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}.lst-kix_bnzmjmjaf2k3-8>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-1,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-2,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-3,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-4,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-5,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-6,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-7,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-8,decimal) ". "}ul.lst-kix_list_3-1{list-style-type:none}.lst-kix_puk3iz2l9na6-1>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-1}ul.lst-kix_list_3-2{list-style-type:none}.lst-kix_list_5-7>li{counter-increment:lst-ctn-kix_list_5-7}ul.lst-kix_list_3-0{list-style-type:none}ol.lst-kix_list_1-7{list-style-type:none}ul.lst-kix_list_3-5{list-style-type:none}.lst-kix_puk3iz2l9na6-7>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-1,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-2,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-3,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-4,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-5,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-6,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-7,decimal) ". "}ol.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}ol.lst-kix_list_2-5.start{counter-reset:lst-ctn-kix_list_2-5 0}li.li-bullet-1:before{margin-left:-21.6pt;white-space:nowrap;display:inline-block;min-width:21.6pt}.lst-kix_list_2-6>li{counter-increment:lst-ctn-kix_list_2-6}.lst-kix_list_4-1>li:before{content:"o  "}.lst-kix_bnzmjmjaf2k3-4>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-4}.lst-kix_puk3iz2l9na6-2>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-2}.lst-kix_list_4-3>li:before{content:"\\0025cf  "}.lst-kix_list_4-5>li:before{content:"\\0025aa  "}.lst-kix_cqy89pbleymu-1>li{counter-increment:lst-ctn-kix_cqy89pbleymu-1}ol.lst-kix_list_5-7.start{counter-reset:lst-ctn-kix_list_5-7 0}.lst-kix_list_1-8>li{counter-increment:lst-ctn-kix_list_1-8}ol.lst-kix_list_1-4.start{counter-reset:lst-ctn-kix_list_1-4 0}.lst-kix_list_5-5>li{counter-increment:lst-ctn-kix_list_5-5}ol.lst-kix_bnzmjmjaf2k3-5.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-5 0}ol.lst-kix_list_1-1.start{counter-reset:lst-ctn-kix_list_1-1 0}.lst-kix_cqy89pbleymu-0>li{counter-increment:lst-ctn-kix_cqy89pbleymu-0}li.li-bullet-9:before{margin-left:-36pt;white-space:nowrap;display:inline-block;min-width:36pt}.lst-kix_cqy89pbleymu-6>li{counter-increment:lst-ctn-kix_cqy89pbleymu-6}.lst-kix_puk3iz2l9na6-8>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-8}ol.lst-kix_list_1-3.start{counter-reset:lst-ctn-kix_list_1-3 0}ol.lst-kix_list_2-8.start{counter-reset:lst-ctn-kix_list_2-8 0}ol.lst-kix_list_1-2.start{counter-reset:lst-ctn-kix_list_1-2 0}li.li-bullet-11:before{margin-left:-36pt;white-space:nowrap;display:inline-block;min-width:36pt}ol.lst-kix_cqy89pbleymu-7.start{counter-reset:lst-ctn-kix_cqy89pbleymu-7 0}.lst-kix_list_1-1>li:before{content:"" counter(lst-ctn-kix_list_1-1,lower-latin) ". "}.lst-kix_bnzmjmjaf2k3-5>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-5}.lst-kix_puk3iz2l9na6-1>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-1,decimal) ". "}.lst-kix_list_1-3>li:before{content:"" counter(lst-ctn-kix_list_1-3,decimal) ". "}li.li-bullet-16:before{margin-left:-20.4pt;white-space:nowrap;display:inline-block;min-width:20.4pt}.lst-kix_puk3iz2l9na6-5>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-1,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-2,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-3,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-4,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-5,decimal) ". "}.lst-kix_list_1-7>li:before{content:"" counter(lst-ctn-kix_list_1-7,lower-latin) ". "}ol.lst-kix_list_5-8.start{counter-reset:lst-ctn-kix_list_5-8 0}ol.lst-kix_bnzmjmjaf2k3-6.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-6 0}ol.lst-kix_list_2-7.start{counter-reset:lst-ctn-kix_list_2-7 0}.lst-kix_puk3iz2l9na6-3>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-1,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-2,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-3,decimal) ". "}.lst-kix_list_1-3>li{counter-increment:lst-ctn-kix_list_1-3}.lst-kix_list_1-5>li:before{content:"" counter(lst-ctn-kix_list_1-5,lower-roman) ". "}li.li-bullet-4:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}.lst-kix_list_5-6>li{counter-increment:lst-ctn-kix_list_5-6}.lst-kix_list_2-1>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) ". "}ol.lst-kix_cqy89pbleymu-8.start{counter-reset:lst-ctn-kix_cqy89pbleymu-8 0}.lst-kix_list_2-3>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) ". "}.lst-kix_list_5-1>li{counter-increment:lst-ctn-kix_list_5-1}ol.lst-kix_bnzmjmjaf2k3-3.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-3 0}.lst-kix_puk3iz2l9na6-6>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-6}.lst-kix_list_1-1>li{counter-increment:lst-ctn-kix_list_1-1}ol.lst-kix_list_2-6.start{counter-reset:lst-ctn-kix_list_2-6 0}.lst-kix_list_3-0>li:before{content:"\\0025cf  "}.lst-kix_list_3-1>li:before{content:"o  "}.lst-kix_list_3-2>li:before{content:"\\0025aa  "}ol.lst-kix_list_1-8.start{counter-reset:lst-ctn-kix_list_1-8 0}.lst-kix_list_4-0>li{counter-increment:lst-ctn-kix_list_4-0}.lst-kix_list_3-5>li:before{content:"\\0025aa  "}.lst-kix_list_3-4>li:before{content:"o  "}.lst-kix_bnzmjmjaf2k3-8>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-8}.lst-kix_list_3-3>li:before{content:"\\0025cf  "}.lst-kix_list_3-8>li:before{content:"\\0025aa  "}ol.lst-kix_bnzmjmjaf2k3-0{list-style-type:none}.lst-kix_list_2-0>li{counter-increment:lst-ctn-kix_list_2-0}ol.lst-kix_bnzmjmjaf2k3-1{list-style-type:none}ol.lst-kix_bnzmjmjaf2k3-2{list-style-type:none}ol.lst-kix_bnzmjmjaf2k3-3{list-style-type:none}ol.lst-kix_bnzmjmjaf2k3-4{list-style-type:none}.lst-kix_list_3-6>li:before{content:"\\0025cf  "}ol.lst-kix_bnzmjmjaf2k3-5{list-style-type:none}ol.lst-kix_puk3iz2l9na6-8{list-style-type:none}ol.lst-kix_bnzmjmjaf2k3-6{list-style-type:none}.lst-kix_list_3-7>li:before{content:"o  "}ol.lst-kix_puk3iz2l9na6-7{list-style-type:none}ol.lst-kix_bnzmjmjaf2k3-7{list-style-type:none}ol.lst-kix_puk3iz2l9na6-6{list-style-type:none}ol.lst-kix_bnzmjmjaf2k3-8{list-style-type:none}ol.lst-kix_puk3iz2l9na6-5{list-style-type:none}ol.lst-kix_list_5-0.start{counter-reset:lst-ctn-kix_list_5-0 0}ol.lst-kix_bnzmjmjaf2k3-8.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-8 0}ol.lst-kix_puk3iz2l9na6-2.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-2 0}ol.lst-kix_list_2-2{list-style-type:none}ol.lst-kix_list_2-3{list-style-type:none}ol.lst-kix_list_2-4{list-style-type:none}ol.lst-kix_list_2-5{list-style-type:none}ol.lst-kix_list_2-0{list-style-type:none}ol.lst-kix_list_2-1{list-style-type:none}.lst-kix_list_4-8>li:before{content:"\\0025aa  "}.lst-kix_bnzmjmjaf2k3-6>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-6}.lst-kix_list_4-7>li:before{content:"o  "}li.li-bullet-7:before{margin-left:-36pt;white-space:nowrap;display:inline-block;min-width:36pt}ul.lst-kix_list_4-8{list-style-type:none}ol.lst-kix_puk3iz2l9na6-4{list-style-type:none}ol.lst-kix_list_5-6.start{counter-reset:lst-ctn-kix_list_5-6 0}ol.lst-kix_puk3iz2l9na6-3{list-style-type:none}ul.lst-kix_list_4-6{list-style-type:none}ol.lst-kix_puk3iz2l9na6-2{list-style-type:none}ul.lst-kix_list_4-7{list-style-type:none}ol.lst-kix_puk3iz2l9na6-1{list-style-type:none}li.li-bullet-10:before{margin-left:-36pt;white-space:nowrap;display:inline-block;min-width:36pt}ol.lst-kix_puk3iz2l9na6-0{list-style-type:none}ol.lst-kix_puk3iz2l9na6-1.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-1 0}ol.lst-kix_cqy89pbleymu-4.start{counter-reset:lst-ctn-kix_cqy89pbleymu-4 0}li.li-bullet-14:before{margin-left:-36pt;white-space:nowrap;display:inline-block;min-width:36pt}ol.lst-kix_puk3iz2l9na6-8.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-8 0}ul.lst-kix_list_4-1{list-style-type:none}ul.lst-kix_list_4-4{list-style-type:none}ol.lst-kix_list_2-6{list-style-type:none}ul.lst-kix_list_4-5{list-style-type:none}ol.lst-kix_list_2-7{list-style-type:none}ul.lst-kix_list_4-2{list-style-type:none}ol.lst-kix_list_2-8{list-style-type:none}ul.lst-kix_list_4-3{list-style-type:none}ol.lst-kix_bnzmjmjaf2k3-4.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-4 0}.lst-kix_cqy89pbleymu-8>li{counter-increment:lst-ctn-kix_cqy89pbleymu-8}ol.lst-kix_cqy89pbleymu-5.start{counter-reset:lst-ctn-kix_cqy89pbleymu-5 0}ol.lst-kix_list_5-5.start{counter-reset:lst-ctn-kix_list_5-5 0}.lst-kix_cqy89pbleymu-5>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-5,lower-roman) ". "}.lst-kix_list_2-2>li{counter-increment:lst-ctn-kix_list_2-2}ol.lst-kix_puk3iz2l9na6-7.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-7 0}ol.lst-kix_list_5-0{list-style-type:none}.lst-kix_list_2-6>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) ". "}.lst-kix_cqy89pbleymu-4>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-4,lower-latin) ". "}ol.lst-kix_list_5-1{list-style-type:none}ol.lst-kix_puk3iz2l9na6-3.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-3 0}.lst-kix_bnzmjmjaf2k3-1>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-1,decimal) ". "}.lst-kix_bnzmjmjaf2k3-3>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-1,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-2,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-3,decimal) ". "}ol.lst-kix_list_5-2{list-style-type:none}.lst-kix_list_2-4>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) ". "}.lst-kix_list_2-8>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) "." counter(lst-ctn-kix_list_2-7,decimal) "." counter(lst-ctn-kix_list_2-8,decimal) ". "}.lst-kix_cqy89pbleymu-2>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-2,lower-roman) ". "}.lst-kix_bnzmjmjaf2k3-3>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-3}.lst-kix_cqy89pbleymu-0>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-0,decimal) ". "}.lst-kix_cqy89pbleymu-7>li:before{content:"" counter(lst-ctn-kix_cqy89pbleymu-7,lower-latin) ". "}.lst-kix_bnzmjmjaf2k3-5>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-1,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-2,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-3,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-4,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-5,decimal) ". "}.lst-kix_bnzmjmjaf2k3-7>li:before{content:"" counter(lst-ctn-kix_bnzmjmjaf2k3-0,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-1,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-2,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-3,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-4,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-5,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-6,decimal) "." counter(lst-ctn-kix_bnzmjmjaf2k3-7,decimal) ". "}.lst-kix_cqy89pbleymu-3>li{counter-increment:lst-ctn-kix_cqy89pbleymu-3}ol.lst-kix_list_5-4.start{counter-reset:lst-ctn-kix_list_5-4 0}.lst-kix_bnzmjmjaf2k3-2>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-2}ol.lst-kix_list_5-1.start{counter-reset:lst-ctn-kix_list_5-1 0}ol.lst-kix_puk3iz2l9na6-6.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-6 0}ol.lst-kix_list_5-7{list-style-type:none}ol.lst-kix_list_5-8{list-style-type:none}.lst-kix_puk3iz2l9na6-6>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-1,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-2,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-3,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-4,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-5,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-6,decimal) ". "}ol.lst-kix_list_5-3{list-style-type:none}ol.lst-kix_list_5-4{list-style-type:none}.lst-kix_puk3iz2l9na6-8>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-1,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-2,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-3,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-4,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-5,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-6,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-7,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-8,decimal) ". "}.lst-kix_list_1-7>li{counter-increment:lst-ctn-kix_list_1-7}ol.lst-kix_list_5-5{list-style-type:none}ol.lst-kix_list_5-6{list-style-type:none}.lst-kix_cqy89pbleymu-2>li{counter-increment:lst-ctn-kix_cqy89pbleymu-2}ol.lst-kix_cqy89pbleymu-0.start{counter-reset:lst-ctn-kix_cqy89pbleymu-0 0}li.li-bullet-17:before{margin-left:-36pt;white-space:nowrap;display:inline-block;min-width:36pt}.lst-kix_list_5-8>li{counter-increment:lst-ctn-kix_list_5-8}.lst-kix_list_4-0>li:before{content:"" counter(lst-ctn-kix_list_4-0,lower-latin) ") "}li.li-bullet-15:before{margin-left:-20.4pt;white-space:nowrap;display:inline-block;min-width:20.4pt}li.li-bullet-3:before{margin-left:-25.2pt;white-space:nowrap;display:inline-block;min-width:25.2pt}.lst-kix_bnzmjmjaf2k3-1>li{counter-increment:lst-ctn-kix_bnzmjmjaf2k3-1}ol.lst-kix_bnzmjmjaf2k3-2.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-2 0}ol.lst-kix_list_1-7.start{counter-reset:lst-ctn-kix_list_1-7 0}.lst-kix_list_4-4>li:before{content:"o  "}ol.lst-kix_list_2-2.start{counter-reset:lst-ctn-kix_list_2-2 0}.lst-kix_cqy89pbleymu-4>li{counter-increment:lst-ctn-kix_cqy89pbleymu-4}.lst-kix_list_1-5>li{counter-increment:lst-ctn-kix_list_1-5}ol.lst-kix_cqy89pbleymu-3.start{counter-reset:lst-ctn-kix_cqy89pbleymu-3 0}.lst-kix_list_4-2>li:before{content:"\\0025aa  "}.lst-kix_list_4-6>li:before{content:"\\0025cf  "}ol.lst-kix_list_4-0{list-style-type:none}ol.lst-kix_cqy89pbleymu-1.start{counter-reset:lst-ctn-kix_cqy89pbleymu-1 0}.lst-kix_list_2-4>li{counter-increment:lst-ctn-kix_list_2-4}li.li-bullet-8:before{margin-left:-20.4pt;white-space:nowrap;display:inline-block;min-width:20.4pt}ol.lst-kix_puk3iz2l9na6-5.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-5 0}ol.lst-kix_bnzmjmjaf2k3-1.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-1 0}li.li-bullet-5:before{margin-left:-25.2pt;white-space:nowrap;display:inline-block;min-width:25.2pt}li.li-bullet-12:before{margin-left:-36pt;white-space:nowrap;display:inline-block;min-width:36pt}.lst-kix_list_5-3>li{counter-increment:lst-ctn-kix_list_5-3}.lst-kix_list_1-0>li:before{content:"" counter(lst-ctn-kix_list_1-0,decimal) ". "}.lst-kix_list_1-2>li:before{content:"" counter(lst-ctn-kix_list_1-2,lower-roman) ". "}ol.lst-kix_list_2-0.start{counter-reset:lst-ctn-kix_list_2-0 0}.lst-kix_puk3iz2l9na6-4>li{counter-increment:lst-ctn-kix_puk3iz2l9na6-4}.lst-kix_puk3iz2l9na6-2>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-1,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-2,decimal) ". "}.lst-kix_list_1-4>li:before{content:"" counter(lst-ctn-kix_list_1-4,lower-latin) ". "}.lst-kix_list_1-0>li{counter-increment:lst-ctn-kix_list_1-0}ol.lst-kix_puk3iz2l9na6-4.start{counter-reset:lst-ctn-kix_puk3iz2l9na6-4 0}.lst-kix_list_1-6>li{counter-increment:lst-ctn-kix_list_1-6}.lst-kix_puk3iz2l9na6-4>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-1,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-2,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-3,decimal) "." counter(lst-ctn-kix_puk3iz2l9na6-4,decimal) ". "}.lst-kix_list_1-6>li:before{content:"" counter(lst-ctn-kix_list_1-6,decimal) ". "}li.li-bullet-0:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}.lst-kix_list_2-0>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) ". "}ol.lst-kix_list_2-1.start{counter-reset:lst-ctn-kix_list_2-1 0}.lst-kix_list_1-8>li:before{content:"" counter(lst-ctn-kix_list_1-8,lower-roman) ". "}.lst-kix_list_2-2>li:before{content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) ". "}.lst-kix_puk3iz2l9na6-0>li:before{content:"" counter(lst-ctn-kix_puk3iz2l9na6-0,decimal) ". "}ol.lst-kix_list_5-2.start{counter-reset:lst-ctn-kix_list_5-2 0}ol.lst-kix_bnzmjmjaf2k3-0.start{counter-reset:lst-ctn-kix_bnzmjmjaf2k3-0 0}ol{margin:0;padding:0}table td,table th{padding:0}.c21{-webkit-text-decoration-skip:none;color:#000000;font-weight:700;text-decoration:underline;vertical-align:baseline;text-decoration-skip-ink:none;font-size:14pt;font-family:"Arial";font-style:normal}.c3{margin-left:53.5pt;padding-top:0pt;padding-left:7.2pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c10{margin-left:25.1pt;padding-top:0pt;padding-left:2.4pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c12{margin-left:39.2pt;padding-top:0pt;padding-left:18pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c5{margin-left:50pt;padding-top:0pt;padding-left:18pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c9{margin-left:60.5pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c1{margin-left:36pt;padding-top:0pt;padding-left:3.6pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c6{margin-left:18pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c11{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left;height:11pt}.c22{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:right;height:11pt}.c4{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Arial";font-style:normal}.c0{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Arial";font-style:normal}.c15{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Calibri";font-style:normal}.c13{padding-top:0pt;padding-bottom:8pt;line-height:1.5;orphans:2;widows:2;text-align:left}.c19{padding-top:0pt;padding-bottom:8pt;line-height:1.5;orphans:2;widows:2;text-align:center}.c7{font-size:12pt;font-family:"Arial";font-weight:400}.c24{background-color:#ffffff;max-width:451.3pt;padding:72pt 72pt 72pt 72pt}.c18{font-size:12pt;font-family:"Arial";font-weight:700}.c14{margin-left:18pt;text-indent:-18pt;height:11pt}.c16{margin-left:39.2pt;padding-left:18pt}.c2{padding:0;margin:0}.c23{margin-left:39.6pt;height:11pt}.c25{color:#000000;text-decoration:none}.c20{margin-left:36pt;padding-left:3.6pt}.c8{color:inherit;text-decoration:inherit}.c26{height:11pt}.c17{vertical-align:super}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:"Georgia";line-height:1.0791666666666666;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Calibri"}p{margin:0;color:#000000;font-size:11pt;font-family:"Calibri"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:14pt;color:#000000;font-weight:700;font-size:14pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:12pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0791666666666666;page-break-after:avoid;orphans:2;widows:2;text-align:left}',
        }}
      />
      <div>
        <p className="c11">
          <span className="c15" />
        </p>
      </div>
      <p className="c19">
        <span className="c21">TERMS AND CONDITIONS</span>
      </p>
      <p className="c13">
        <span className="c4">Last updated date: January 19, 2024.</span>
      </p>
      <p className="c13">
        <span className="c4">
          Important Message: Please carefully review these Terms of Use
          ("Terms", "Terms of Use", or "Agreement") before using this online or
          mobile entertainment service, as they have legal implications that
          affect your rights and obligations, including waivers of rights,
          limitation of liability, and your obligation to indemnify us. This
          Agreement mandates the use of arbitration on an individual basis to
          resolve disputes, rather than courts, jury trials, or class actions,
          and restricts the remedies available in case of a dispute.{" "}
        </span>
      </p>
      <p className="c13">
        <span className="c7">
          This Agreement (“Agreement”) is entered between - Qunions Studios
          having its registered office at 90 Jagannath Puri, Mathura, UP –
          281001, through its website{" "}
        </span>
        <span className="c7 c25">
          <a
            className="c8"
            href="https://www.google.com/url?q=http://www.qunions.com&sa=D&source=editors&ust=1682035915883903&usg=AOvVaw26xwKEtw9lz_yr66nxCYpC"
          >
            www.qunions.com
          </a>
        </span>
        <span className="c4">
          , and ‘You’ as the User on the website. The terms such as ‘Company’,
          ‘Platform’, and ‘Qunions’ shall be used in reference to the Platform,
          and the terms such as ‘You’, ‘User’, and ‘End User’ shall be used in
          reference to the User of the website.
        </span>
      </p>
      <p className="c13">
        <span className="c0">
          NOW, THEREFORE, IN CONSIDERATION OF THE PROMISES AND MUTUAL COVENANTS
          SET FORTH HEREIN, THE PARTIES HERETO, INTENDING TO BE LEGALLY BOUND,
          HEREBY AGREE AS FOLLOWS:
        </span>
      </p>
      <p className="c13 c14">
        <span className="c4" />
      </p>
      <ol className="c2 lst-kix_list_2-0 start" start={1}>
        <li className="c6 li-bullet-0">
          <span className="c0">ACCEPTANCE:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            In order to use the Services, you must first agree to the Terms. If
            you do not agree to the Terms, you are not allowed to use the
            Services. You can accept the Terms by:
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-2 start" start={1}>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Clicking to accept or agree to the Terms where this option is
            provided in the user interface for any Service, or
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">Using the Services.</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1" start={2}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            By continuing to use the Services, you understand and agree that
            Qunions will consider your continued use of the Services as
            acceptance of the Terms. However, you may not use the Services or
            accept the Terms if:
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-2 start" start={1}>
        <li className="c3 li-bullet-3">
          <span className="c4">
            You are not of legal age to form a binding contract with Qunions, or
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            You are a person prohibited from receiving the Services under the
            laws of India or any other country, including the country where you
            reside or use the Services. Before proceeding, it is recommended to
            print or save a local copy of the Qunions Terms for your records.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={2}>
        <li className="c6 li-bullet-0">
          <span className="c0">PARTICIPATION:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            All transactions on the platform are conducted in a{" "}
            <span
              style={{
                fontWeight: "bold",
              }}
            >
              virtual currency environment
            </span>
            , with the platform using "Rewards balance" as a term for their
            local virtual currency. When engaging in opinion trading on
            post-event analysis/discussions, users do not risk losing real
            money. Eligible rewards balance recharges are free, and real money
            gift cards can be obtained using rewards money at different
            milestones, with varying exchange rates between 1% and 10% . By using
            the platform, users acknowledge and agree to participate in a
            virtual currency environment to win real money gift cards.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            User agrees to comply by the official rules of contests explained
            below. These rules can also be referred to any time within the App
            in the "How to Play" section in the settings menu, "Get ready to
            Play and Win" section on the Home page, "Help" (bulb icon) icon on
            the top right hand side of the home page, "Weekly League Rules" in
            the Weekly League section, and within any contest in "How to Play"
            section.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Qunions reserves the right to distribute and analyze the redemption
            of gift cards in a fair manner. Any misconduct, including but not
            limited to creating multiple accounts by a single user, not abiding
            by FairPlay policies, exploiting app features unfairly, or engaging
            in other prohibited activities, may result in the revocation of
            eligibility to avail real money gift cards. Users acknowledge and
            agree to these terms.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            In any and all contests, Apple is not a sponsor in any shape or
            form.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            In any and all contests, Google is not a sponsor in any shape or
            form.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Qunions provides users with a platform to trade opinions on
            post-event analysis and discussions. On the platform, there are only
            opinions to a question and no single factual correct answer. Users
            acknowledge this fact and cannot claim any particular option as a
            correct answer.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c0">Qunions "Open Trades"</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-2 start" start={1}>
        <li className="c3 li-bullet-3">
          <span className="c4">
            For all trade questions, there are multiple opinion-based options.
            Users can invest in any option within a minimum and maximum range
            for that trade. Two out of all options in any/all trades are winning
            options. The option that receives the most votes is the "Majority"
            category winning option, and the option that receives the least
            votes is the "Minority" category winning option. All investments on
            the winning options yield returns based on their respective winning
            category's final return percentage. All other investments that are
            not on the winning options yield no returns. Users understand and
            accept the platform's methodology of winning and not winning a
            trade.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Until a trade is closed, the winning return percentage for that
            trade on either of the winning categories may change as more users
            enter the trade or existing users edit their responses. The platform
            allows for response editing before the close of a trade. Once a
            trade is closed, the last response to that trade is considered
            final. Users understand and accept the trade-off between the
            variability of "winning returns" and the flexibility of "editing the
            response" as part of the overall experience.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Winning return percentages on either of the winning categories are
            calculated and displayed in real time on the App using Qunions'
            proprietary algorithm. This algorithm quantifies the difficulty of
            identifying the winning category (Majority or Minority) in the
            population. Higher difficulty corresponds to lower separability and
            higher returns. Users understand and accept the platform's criteria
            for redistributing all investments on a trade between the winning
            options as per the platform's algorithm.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Although the winning return percentages are calculated in real time,
            they are published on the App with some time lag and controlled
            frequency. The time lag and publication frequency control measures
            are in place to provide a smoother user experience. Users
            acknowledge this fact in support of a better overall user
            experience.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Once a user has entered a trade, they cannot withdraw from it.
            However, they can edit their response, including changing or
            minimizing their investment, any number of times before the close of
            the trade.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Qunions reserves the right to abandon any trade question or any of
            the options, or adjust the deadline for the close of a trade in
            certain unforeseen circumstances. The platform will notify users of
            any changes, and all investments will be reversed accordingly.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Investing in certain trades may be subject to specific rules that
            will be notified to users by Qunions for that trade. These rules
            will be in addition to the Terms and Conditions.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Users have the option to visit and analyze the archived trades in
            order to understand the psychology of the population and formulate
            their own strategies for active trades. However, the platform does
            not assume any responsibility for any correlation or causation, or
            lack thereof, between archived trades and active trades.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1" start={5}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            All users acknowledge and understand that participation on the
            Qunions Platform in various formats is based on their individual
            analysis of winning objectives and their perception of the overall
            population's opinion/strategy. Such analysis may or may not
            correlate with actual facts or the actual opinion of the population.
            Qunions does not assume any responsibility for any correlation or
            lack thereof between any independent population survey and Qunions'
            statistics.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c0">Qunions "Live Game"</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-2 start" start={1}>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Live games on the Qunions platform are private events to be
            conducted within a user's own group. All users must invite or
            participate within their known acquaintances and should not spam
            unknown individuals without their consent.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            The user assumes full responsibility for extending invitations to
            others to join their group or for participating in another user's
            group. Any experiences, events, or activities related to private
            groups, including but not limited to interactions among group
            members, decisions made within the group, and any outcomes or
            consequences arising from such interactions or decisions, are solely
            between the user and their host. Qunions shall not be held
            responsible or liable for any actions, omissions, or consequences
            related to private groups on the Qunions platform, including but not
            limited to any disputes, conflicts, losses, damages, or claims
            arising from or in connection with the user's participation in or
            interaction with private groups.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={3}>
        <li className="c6 li-bullet-4">
          <span className="c0">USER CONDUCT: </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Respectful Communication: Users are expected to communicate with
            each other in a respectful and courteous manner. Any form of
            abusive, offensive, or discriminatory language or behavior towards
            other users will not be tolerated.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Appropriate Content: Users are responsible for the content they post
            on the app, including questions, opinions, and comments. Content
            that is illegal, obscene, defamatory, threatening, or promotes
            violence, discrimination, or harassment of any kind is strictly
            prohibited.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Privacy and Confidentiality: Users must respect the privacy and
            confidentiality of other users. Sharing the personal information of
            other users without their consent is strictly prohibited. Users
            should also refrain from discussing or sharing any confidential
            information related to the virtual trading platform or virtual money
            fantasy events.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Fair Play: Users should engage in fair play while participating in
            the virtual trading platform and virtual money fantasy events. Any
            form of cheating, manipulation, or exploitation of app features or
            other users is strictly prohibited. Users are expected to adhere to
            the rules and guidelines of the app and the specific events they are
            participating in.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            No Spamming or Advertising: Users should refrain from spamming or
            promoting any form of advertising, including self-promotion or
            third-party promotion, on the app. Users should also avoid excessive
            posting or repetitive content that disrupts the user experience of
            others.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Respect Intellectual Property: Users should not engage in any
            activities that violate intellectual property rights, including
            copyrights, trademarks, patents, or trade secrets. Users should not
            upload or share any content that infringes upon the intellectual
            property rights of others.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Reporting of Violations: Users are encouraged to report any
            violations of the user conduct guidelines or any other suspicious or
            inappropriate activities on the app to the app administrators or
            moderators. This will help in maintaining a safe and enjoyable
            environment for all users.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Compliance with Laws: Users must comply with all applicable laws and
            regulations while using the app. Any activities that are illegal,
            fraudulent, or violate any local, national, or international laws
            are strictly prohibited.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Users agree not to use Qunions for any of the following:
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-2 start" start={1}>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Obscene, offensive, indecent, racial, communal, anti-national,
            objectionable, defamatory, or abusive action or communication.
          </span>
        </li>
        <li className="c3 li-bullet-5">
          <span className="c4">
            Harassment, stalking, threats, or other violations of the legal
            rights of others.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Transmission of inappropriate, profane, defamatory, infringing,
            obscene, indecent, or unlawful content.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Transmission of files that contain viruses, corrupted files, or
            other similar software or programs that may damage or adversely
            affect the operation of another person's computer, Qunions, any
            software, hardware, or telecommunications equipment.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Advertising, offering, or selling any goods or services for any
            commercial purpose on Qunions without the express written consent of
            Qunions.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Downloading any file, recompiling or disassembling, or otherwise
            affecting Qunions's products that you know or reasonably should know
            cannot be legally obtained in such a manner.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Falsifying or deleting any author attributions, legal or other
            proper notices, or proprietary designations or labels of the origin
            or the source of software or other material.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Restricting or inhibiting any other user from using and enjoying any
            public area within Qunions's sites.
          </span>
        </li>
        <li className="c3 li-bullet-5">
          <span className="c4">
            Collecting or storing personal information about other users.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Interfering with or disrupting Qunions and/or the Qunions Platform,
            Qunions servers, or Qunions networks.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Impersonating any person or entity, including but not limited to a
            representative of Qunions, or falsely stating or otherwise
            misrepresenting a user's affiliation with a person or entity.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Forging headers or manipulating identifiers or other data in order
            to disguise the origin of any content transmitted through Qunions or
            to manipulate a user's presence on Qunions(s).
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Taking any action that imposes an unreasonably or disproportionately
            large load on Qunions's infrastructure.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">Engaging in any illegal activities.</span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Engaging in any activity that threatens the unity, integrity,
            defense, security, or sovereignty of India, friendly relations with
            foreign states, or public order, or causes incitement to the
            commission of any cognizable offense or prevents investigation of
            any offense or is insulting other nations.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1" start={10}>
        <li className="c13 c20 li-bullet-1">
          <span className="c4">Consequences of Violation:</span>
        </li>
      </ol>
      <p className="c13 c26">
        <span className="c4" />
      </p>
      <ol className="c2 lst-kix_list_2-2" start={16}>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Violation of the user conduct guidelines may result in consequences,
            including but not limited to:
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_4-0 start" start={1}>
        <li className="c9 li-bullet-0">
          <span className="c4">
            Suspension or termination of the user account
          </span>
        </li>
        <li className="c9 li-bullet-0">
          <span className="c4">Removal of offending content</span>
        </li>
        <li className="c9 li-bullet-0">
          <span className="c4">
            A temporary or permanent ban from using the app
          </span>
        </li>
        <li className="c9 li-bullet-4">
          <span className="c4">
            Legal action as per applicable laws and regulations
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            The app administrators or moderators reserve the right to take
            appropriate actions in response to any violations of the user
            conduct guidelines, as deemed necessary, to ensure the safety and
            integrity of the app and its users.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={4}>
        <li className="c6 li-bullet-4">
          <span className="c0">LIMITATION OF LIABILITY: </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Qunions users are responsible for their own actions and decisions
            when using the Qunions Platform. Qunions is not liable for any
            losses or damages that may occur as a result of using the Qunions
            Platform, including but not limited to personal injury, property
            damage, or financial loss.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            By using the Qunions Platform, users agree to release and indemnify
            Qunions and its affiliates from any and all claims, damages, losses,
            expenses, costs, and liabilities (including attorneys' fees) arising
            out of or in any way connected with their use of the Qunions
            Platform.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Qunions does not guarantee the accuracy or completeness of the
            information provided on the Qunions Platform. Qunions is not liable
            for any errors or omissions in the information provided on the
            Qunions Platform.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Users are responsible for taking all necessary precautions to
            protect themselves from viruses, malware, and other harmful content
            that may be found on the Qunions Platform.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Qunions is not liable for any damages that may occur as a result of
            using the Qunions Platform, including but not limited to computer
            viruses, hardware failures, or software malfunctions.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            If you have any questions about these terms and conditions, please
            contact Qunions at support@qunions.com.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={5}>
        <li className="c6 li-bullet-0">
          <span className="c0">DISCLAIMER:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            We reserve the right to terminate this business model at our
            discretion, upon which the virtual currency in the user's account
            will be converted to real cash prizes at a conversion rate of 5%.
            For example, if a user has Rs 5000 worth of rewards in their
            account, it will be converted to real Rs 250 cash prizes.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Qunions, its parent/holding company, subsidiaries, affiliates,
            directors, officers, professional advisors, and employees shall not
            be held responsible, to the extent permitted by law, for any
            deletion, failure to store, misdelivery, or untimely delivery of
            information or material. Qunions shall also not be responsible for
            any harm resulting from downloading or accessing information or
            material, the quality of servers, products, Qunions Services, or
            sites.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            The User acknowledges that any material accessed, downloaded, or
            obtained through the Qunions Platform is at their discretion,
            competence, acceptance, and risk and that they will be solely
            responsible for any potential damage to their computer system or
            loss of data resulting from such downloads.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            While Qunions will make its best efforts to ensure that the Qunions
            Platform is error-free and secure, neither Qunions nor any of its
            partners, licensors, or associates make any warranty regarding the
            fulfillment of the User's requirements, uninterrupted, timely,
            secure, or error-free operation of the Qunions Platform, accuracy or
            reliability of results obtained from its use, or the quality of any
            products, Qunions Services, information, or other material obtained
            through the Qunions Platform meeting User's expectations.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            In the event of Qunions discovering any errors, Qunions reserves the
            right (exercisable at its discretion) to rectify the error in a
            manner it deems fit, including through set-off of the erroneous
            payment from amounts due to the User or deduction from the User's
            account. Qunions agrees to notify the User of the error and the
            exercise of any remedy to rectify it.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            To the extent permitted by law, neither Qunions nor its partners,
            licensors, or associates shall be liable for any direct, indirect,
            incidental, special, or consequential damages arising from the use
            or inability to use the sites, even if they have been advised of the
            possibility of such damages.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Any Qunions Services hosted or provided on the Qunions platform that
            requires specific permission or authority from statutory
            authorities, state or central government, or the board of directors,
            shall be deemed canceled or terminated if such permission or
            authority is not obtained or denied, either before or after the
            availability of the relevant Qunions Services.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            To the extent permitted by law, in the event of suspension or
            closure of any Qunions Services, Users shall not be entitled to make
            any demands or claims of any nature.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Qunions does not guarantee that all aspects of the Service are
            appropriate or available for use in any particular jurisdiction. By
            accessing and using the Service, you acknowledge and agree that:
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-2 start" start={1}>
        <li className="c3 li-bullet-3">
          <span className="c4">
            You are accessing and using the Service on your own initiative and
            at your own risk;
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            You will not use the Service if prohibited from receiving products,
            services, or software from the United States;
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            You are responsible for complying with local laws and regulations,
            if applicable;
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            You specifically agree to comply with all applicable laws and
            regulations regarding the transmission of technical data from the
            country in which you reside; and
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            If there is a conflict between any terms in this Agreement and your
            rights in your place of residence, your rights under applicable law
            will prevail with respect to those specific terms.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={6}>
        <li className="c6 li-bullet-6">
          <span className="c0">DISCLAIMER OF WARRANTIES: </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Your use of the Service is at your own risk. The Service is provided
            "as is" and "as available" without any warranties of any kind,
            whether express or implied. To the fullest extent permissible under
            applicable law, Qunions disclaims all warranties, express or
            implied, including but not limited to implied warranties of
            merchantability, fitness for a particular purpose, and
            non-infringement. Qunions does not warrant that the Service will be
            available, uninterrupted, secure, or error-free, that defects will
            be corrected, or that the Service or the servers that make the
            Service available are free of viruses or other harmful components.
            Qunions does not warrant or make any representations regarding the
            use or results of the use of the Service, information, software,
            content, or other materials available through the Service or any
            linked website, app, platform, or service, in terms of correctness,
            accuracy, validity, propriety, reliability, legality, security, or
            otherwise. Qunions makes no warranties that your use of the Service,
            information, software, content, or other materials available through
            the Service or any linked website, app, or service will not infringe
            the rights of others. Qunions assumes no liability or responsibility
            for errors or omissions in such services, information, software,
            content, or other materials available through the Service or any
            linked website, app, platform, or service. If applicable law does
            not allow the exclusion of some or all of the above implied
            warranties, the above exclusions will apply to you only to the
            extent permitted by applicable law.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={7}>
        <li className="c6 li-bullet-0">
          <span className="c0">NOTICE:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            When a party is required to provide another party with notice,
            demand, consent, approval, or communication under this Agreement
            (Notice), such Notice must be given through one of the following
            methods: hand delivery, prepaid post, email, or, in the case of
            Qunions issuing a notice, through the Qunions platform to the
            recipient's address for Notices
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={8}>
        <li className="c6 li-bullet-0">
          <span className="c0">TERMINATION:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            The Company/Platform reserves the sole and exclusive right to
            unilaterally terminate the User's account immediately in the
            following circumstances:
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-2 start" start={1}>
        <li className="c3 li-bullet-3">
          <span className="c4">
            If it is discovered that the User has engaged in activities that
            violate the Terms of Use, Privacy Policy, or any other policies,
            laws, rules, or regulations set forth by governing authorities.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            If the User continues to engage in such activities despite receiving
            notice.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            If the User attempts to manipulate, abuse, distort, or misinterpret
            the Terms of Service, Privacy Policy, or any other policies, laws,
            rules, or regulations set forth by governing authorities for the
            purpose of engaging in unlawful activities.
          </span>
        </li>
        <li className="c3 li-bullet-3">
          <span className="c4">
            If the User harasses, intimidates, provokes, abuses, hurts, or
            participates in any unlawful action against Qunions, the platform,
            and any other individuals associated with Qunions, including
            representatives, agents, and employees.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1" start={2}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            If the User decides to cancel their account, they may do so only
            after ensuring that they have not:
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-2 start" start={1}>
        <li className="c3 li-bullet-3">
          <span className="c4">
            Uploaded, created, or distributed any malicious software, content,
            virus, or destructive algorithm that may cause harm to the Company,
            the Platform, or any other concerned individual/third party.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Violated any provision of the Terms of Service, Privacy Policy, or
            other similar policies, laws, rules, or regulations promulgated by
            governing authorities.
          </span>
        </li>
        <li className="c3 li-bullet-2">
          <span className="c4">
            Once the account is terminated, the Platform/Company shall not grant
            anyone access to the information and shall erase the same within 90
            days from all storage servers and other personalized hardware used
            for the Platform's operation.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={9}>
        <li className="c6 li-bullet-0">
          <span className="c0">INTELLECTUAL PROPERTY RIGHTS:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            All trademarks, service marks, and trade names used by Qunions
            (including, but not limited to, the Qunions name, Qunions corporate
            logo, the Website name, the Website design, and any logos)
            (collectively referred to as "Marks") are either registered or
            unregistered trademarks of Qunions or its affiliates, partners,
            vendors, or licensors. You are not permitted to use, copy,
            reproduce, republish, upload, post, transmit, distribute, or modify
            Qunions trademarks in any way without the prior written consent of
            Qunions, including in advertising or publicity related to the
            distribution of materials on the Website or in the Services.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Without prior written consent, you may not use Qunions' name or any
            language, pictures, or symbols that may imply Qunions' endorsement
            in any written or oral advertising or presentation, brochure,
            newsletter, book, or other written material, as determined by
            Qunions.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Qunions, its licensors, vendors, agents, and/or Content providers
            hold ownership of all the content displayed on the Website or in the
            Services, including text, graphics, photographs, images, moving
            images, sound, and illustrations ("Content"). The Website and
            Services, including the general design and the Content, are
            protected by trade dress, copyright, moral rights, trademark, and
            other intellectual property laws. The use of the Website and
            Services is limited to the intended purpose for which they are made
            available.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            You are not allowed to modify any of the materials on the Website,
            and you may not copy, distribute, transmit, display, perform,
            reproduce, publish, license, create derivative works, transfer, or
            sell any information or work contained on the Website, except as
            permitted by copyright law. Prior permission must be obtained before
            reusing any copyrighted material available on the Website or in the
            Services, as authorized by copyright laws.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            You must comply with all applicable domestic and international laws,
            statutes, ordinances, and regulations when using the Website. Unless
            expressly agreed otherwise, the Website, the Services, its Content,
            and all related rights shall remain the exclusive property of
            Qunions or its licensors.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={10}>
        <li className="c6 li-bullet-4">
          <span className="c0">GOVERNING LAW:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            This Agreement shall be governed by the laws of India and shall be
            subject to the jurisdiction of the courts of Mathura, India.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={11}>
        <li className="c6 li-bullet-4">
          <span className="c0">DISPUTE RESOLUTION:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c1 li-bullet-1">
          <span className="c4">
            In the event of a dispute, disagreement, or difference arising from,
            out of, or in relation to the terms specified in the Terms and
            Conditions (referred to as "Dispute"), Qunions and You (collectively
            referred to as "Parties") shall attempt to resolve such Dispute
            amicably through mediation at the earliest opportunity.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            If mediation fails, the Parties shall resort to arbitration for
            effective and binding dispute resolution. The arbitrators shall be
            chosen jointly within two months.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            The arbitration proceedings shall be conducted in English.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            The arbitration shall be held in the court of Mathura, India unless
            otherwise specified in the award.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            Unless otherwise specified in the award, both parties shall bear the
            costs of the arbitration, including the fees of the arbitrators,
            equally.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            The awards and proceedings shall be carried out in accordance with
            the provisions of the applicable law.
          </span>
        </li>
        <li className="c1 li-bullet-1">
          <span className="c4">
            The award issued jointly by the arbitrators shall be considered
            final.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-0" start={12}>
        <li className="c6 li-bullet-4">
          <span className="c0">UPDATES:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_list_2-1 start" start={1}>
        <li className="c13 c20 li-bullet-1">
          <span className="c4">
            Qunions retains the sole discretion to modify these Terms (including
            any applicable Additional Terms) at any time. You acknowledge and
            agree that Qunions may notify you of any changes to the terms or
            policies by posting them on the Service, and that your continued use
            of the Service after such notice constitutes your acceptance of the
            modified terms, which will govern your ongoing use of the Service.
            Therefore, it is your responsibility to review the posted Terms of
            Use and any applicable Additional Terms each time you use the
            Service. Any modifications to these Terms will supersede the prior
            version for all activity occurring after the revised version has
            been made available.
          </span>
        </li>
      </ol>
      <p className="c19">
        <span className="c21">PRIVACY POLICY</span>
      </p>
      <p className="c13">
        <span className="c4">
          This Privacy Policy is intended to inform users of Qunions ("Company")
          about how their personal information is collected, stored, used, and
          protected when they use the Company's website, application, and/or
          Services (as defined in the Terms and Conditions). The terms "we,"
          "us," and "our" refer to the Company, while "you" refers to the user
          of the website, application, and/or Services.
        </span>
      </p>
      <ol className="c2 lst-kix_cqy89pbleymu-0 start" start={1}>
        <li className="c6 li-bullet-4">
          <span className="c0">AGE OF CONSENT:</span>
        </li>
      </ol>
      <ol className="c2">
        <li className="c12" style={{ marginLeft: 0 }}>
          <span className="c4">
            By using our website, you represent and warrant that you are at
            least 18 years old or that you have allowed your child to use the
            website and Services under your supervision and control.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_cqy89pbleymu-0" start={2}>
        <li className="c6 li-bullet-4">
          <span className="c0">CONSENT:</span>
        </li>
      </ol>
      <ol className="c2">
        <li className="c12" style={{ marginLeft: 0 }}>
          <span className="c4">
            By accessing the Company's website, you agree to be bound by this
            Privacy Policy and consent to the Company's collection, storage, and
            use of your personal information, as described in this Privacy
            Policy. Your use of the website or provision of personal
            information, whether or not you register or enroll your child with
            one of our courses, signifies your agreement and consent to our
            collection, use, and disclosure of your personal information and
            receiving emails or communications, as detailed in this Privacy
            Policy.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0 start" start={2}>
        <li className="c10 li-bullet-8">
          <span className="c0">WHAT INFORMATION DO WE COLLECT FROM YOU?</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-9">
          <span className="c4">
            We may gather both "Non-Personal Information" and "Personal
            Information" regarding you. "Non-Personal Information" pertains to
            data that cannot be utilized to recognize you personally, such as
            anonymous usage data, general demographic information that we may
            collect, referring/exit pages and URLs, platform types, preferences
            you submit, and preferences that are generated based on the data you
            submit and the number of clicks. "Personal Information" pertains to
            data that can be utilized to identify you or your child, such as
            your name, address, age, and email address.
          </span>
        </li>
        <li className="c12 li-bullet-10">
          <span className="c18">Analytics: </span>
          <span className="c4">
            We may monitor information regarding your usage of the website. We
            may track information that your browser provides to us or that we
            collect through the website, such as the referring website from
            which you arrived at our website, the kind of browser you use, the
            device you used to connect to the website, the time and date of
            access, and other data that does not personally identify you. We use
            this information for various purposes, such as operating the
            website, improving our services, improving your website experience,
            and understanding different users' diverse requirements, among
            others.
          </span>
        </li>
        <li className="c12 li-bullet-11">
          <span className="c18">Website Forms: </span>
          <span className="c4">
            Our website may feature various online forms that allow you to
            submit personally identifiable information, such as expressing
            interest in our Services or making an inquiry. These forms may be in
            different formats and require your information before submitting.
            When you use these forms, we collect information that identifies
            you, including but not limited to name, age, phone number, email
            address, postal address, and other personally identifiable
            information. We use this information solely to understand your needs
            and suggest appropriate Services. We do not use this information for
            marketing purposes or share it with third parties.
          </span>
        </li>
        <li className="c12 li-bullet-12">
          <span className="c18">Telephonic and Email Communications: </span>
          <span className="c7">
            Based on the Personal Information you provide, we may contact you
            via telephone to better understand your requirements and provide
            additional information about our Services. By providing your phone
            number, you expressly consent to us contacting you even if you have
            registered with a "Do Not Disturb" registry with your telecom
            provider. We may also contact you via email.
          </span>
        </li>
        <li className="c12 li-bullet-11">
          <span className="c4">
            We may also use your Personal Information to send you updates and
            promotional communications. If you no longer wish to receive these
            communications, you may opt out by contacting us.
          </span>
        </li>
        <li className="c12 li-bullet-9">
          <span className="c18">Social Media: </span>
          <span className="c4">
            We may collect information when you interact with our social media
            accounts and pages, such as on LinkedIn, Twitter, Instagram,
            Facebook, and other platforms.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={3}>
        <li className="c10 li-bullet-8">
          <span className="c0">HOW DO WE USE YOUR DATA?</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-12">
          <span className="c4">
            We will use the information provided by you for legitimate business
            purposes such as providing the Services, troubleshooting our
            website, diagnosing problems, and informing you about the Services.
            Additionally, we may use your information for functions related to
            payments, changes in service, reducing instances of fraud, and
            protecting both you and the Company.
          </span>
        </li>
        <li className="c12 li-bullet-9">
          <span className="c4">
            For payment-related information, we use payment aggregators/gateways
            that have their own privacy policies. We advise you to review these
            policies to understand how they handle your Personal Information.
          </span>
        </li>
        <li className="c12 li-bullet-9">
          <span className="c4">
            We may use your Non-Personal Information to improve our Services and
            track website usage. We may also aggregate and anonymize
            Non-Personal Information for our partners, advertisers, and other
            third parties at our discretion. This Privacy Policy does not
            restrict our use or disclosure of Non-Personal Information.
          </span>
        </li>
        <li className="c12 li-bullet-11">
          <span className="c4">
            We use the Personal Data we collect to provide and support our
            Websites and Services, verify account activity, and promote security
            by investigating suspicious activity or violations of our terms,
            policies, or agreements with you. This Personal Data is also used to
            provide information about our Services, register you to use our
            Services, provide customer support, send questionnaires and surveys,
            allow you to apply for positions, personalize our communications and
            Websites, provide access to product documentation, register you for
            events, fulfill our obligations under agreements with users and
            their companies, collect usage statistics, notify you of changes to
            our Services and Websites, and enable you to transfer information to
            a third party if applicable.
          </span>
        </li>
        <li className="c12 li-bullet-12">
          <span className="c4">
            We process Personal Data based on the legal grounds of carrying out
            our contractual obligations to you, fulfilling legal obligations we
            are subject to, and pursuing our legitimate interests and those of
            third parties. When we apply a legitimate interest, we ensure that
            it does not outweigh an individual's interests or rights that
            require the protection of their Personal Data. Our legitimate
            interests include improving and managing the Websites and Services.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={4}>
        <li className="c10 li-bullet-13">
          <span className="c0">PROTECTION OF INFORMATION:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-14">
          <span className="c4">
            We employ reasonable measures to protect your Personal Information
            and prevent it from being illegally or improperly accessed, sold,
            disclosed, altered, or destroyed. However, we cannot guarantee that
            such measures will prevent unauthorized access, disclosure,
            alteration, or destruction of your information. By using our
            website, you acknowledge and accept the risks involved.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={5}>
        <li className="c10 li-bullet-13">
          <span className="c18">WHEN DO WE DISCLOSE YOUR DATA?</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-9">
          <span className="c4">
            Except as outlined in this Privacy Policy or with your explicit
            consent, we will not reveal any of your information, including
            Personal Data, to any third party. We will not sell, rent, exchange,
            or share your information, including Personal Data, with any third
            party for any purpose other than the ones you have requested or
            consented to.
          </span>
        </li>
        <li className="c12 li-bullet-11">
          <span className="c4">
            We do not generally provide your personal information to other
            companies unless it is described in this Privacy Policy.
          </span>
        </li>
        <li className="c12 li-bullet-12">
          <span className="c4">
            We may disclose your personal information in the following ways:
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-2 start" start={1}>
        <li className="c5 li-bullet-9">
          <span className="c4">
            We may share your information with our subsidiaries, joint ventures,
            or other companies that are under common control, and we will make
            sure that they comply with this Privacy Policy. This includes
            sharing data with our affiliated companies' employees worldwide.
          </span>
        </li>
        <li className="c5 li-bullet-12">
          <span className="c4">
            We may share your contact information with business partners who
            help us develop product integrations for our users or host our
            events, but only if you gave your consent during registration. You
            can withdraw your consent by contacting us as stated in the Contact
            Us section.
          </span>
        </li>
        <li className="c5 li-bullet-12">
          <span className="c4">
            We may disclose your personal information to third-party agents and
            service providers who perform tasks on our behalf, such as hosting,
            billing, push notifications, storage, bandwidth, content management
            tools, analytics, customer service, and fraud protection. These
            third parties can only access your personal information to the
            extent required to provide their services. All third parties are
            legally bound to maintain the confidentiality and security of your
            personal information and cannot use it for any other purpose.
          </span>
        </li>
        <li className="c5 li-bullet-11">
          <span className="c4">
            Our websites may contain social media widgets, such as Facebook,
            Twitter, Instagram, and Tumblr, which may collect your IP address
            and the pages you visit and set cookies to enable their features.
            These widgets are hosted by third parties or directly on our
            websites, and your interactions with them are subject to the privacy
            policies of the companies that provide them.
          </span>
        </li>
        <li className="c5 li-bullet-9">
          <span className="c4">
            Our websites may link to other websites or services operated by
            third parties, whose privacy practices may differ from ours and are
            governed by their own privacy policies. We do not control or endorse
            any of these third-party websites or services, and we encourage you
            to carefully review their privacy policies.
          </span>
        </li>
        <li className="c5 li-bullet-9">
          <span className="c4">
            In rare cases, we may disclose your personal information to law
            enforcement or government entities to comply with the law or
            investigate legal claims. If we detect fraudulent activity, we may
            also share information with other companies and organizations for
            fraud protection.
          </span>
        </li>
        <li className="c5 li-bullet-11">
          <span className="c4">
            In connection with a business deal, such as a merger, acquisition,
            or sale of assets, we may sell, transfer, or share some or all of
            our business or assets, including your personal information.
          </span>
        </li>
        <li className="c5 li-bullet-7">
          <span className="c4">
            We may partner with third-party companies who work on our behalf or
            act as processors to provide services to you, such as lead
            qualification or technical infrastructure services. We only share
            information and Personal Data with these partner organizations to
            the extent necessary to support our business and provide our
            Service. These processors are subject to strict data processing
            obligations in accordance with our Service, this Privacy Policy,
            applicable legislation, and any agreements we have with them.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={6}>
        <li className="c10 li-bullet-15">
          <span className="c0">DATA RETENTION:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-11">
          <span className="c7">
            We will retain your personal information only for as long as
            necessary to fulfill the purposes for which it was collected, such
            as providing services, complying with legal obligations, settling
            disputes, and enforcing our agreements.
          </span>
        </li>
        <li className="c12 li-bullet-11">
          <span className="c7">
            Upon termination or deactivation of your account, we will delete
            your Customer Data within 30 days and anonymize your User Metrics.
            However, we may retain your contact information, user profile, and
            other personal data in our records. We will securely delete or
            anonymize your data when it is no longer necessary to retain it for
            the purpose for which it was collected and there is no legal or
            business reason to keep it. If you wish to request the deletion of
            your personal data before the end of our retention period, please
            refer to the Contact Us section.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={7}>
        <li className="c10 li-bullet-16">
          <span className="c0">DATA SECURITY:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-12">
          <span className="c7">
            We prioritize the security of your data and have implemented various
            measures to prevent unauthorized access, alteration, or destruction
            of your personal data, including organizational, technical, and
            physical safeguards.
          </span>
        </li>
        <li className="c12 li-bullet-11">
          <span className="c7">
            While we follow industry standards and best practices for data
            protection, it is important to note that no transmission of data
            over the Internet or any public network can be completely guaranteed
            to be secure.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={8}>
        <li className="c10 li-bullet-15">
          <span className="c0">YOUR DATA RIGHTS:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-11">
          <span className="c7">
            We respect your right to control your personal data and will confirm
            upon request whether we hold or process your data. You have the
            right to correct any inaccurate or incomplete personal data, request
            the deletion of your personal data, or ask us to stop using it.
            However, we may not be able to fulfill your request under certain
            circumstances, such as regulatory requirements, legal matters,
            inability to verify your identity, or disproportionate cost or
            effort. We will respond to your request within a reasonable
            timeframe and provide you with an explanation. You can exercise
            these rights by contacting us through the provided methods.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={9}>
        <li className="c10 li-bullet-8">
          <span className="c0">MISCELLANEOUS:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-12">
          <span className="c7">
            When you make a purchase from us, your payment card details are
            collected and processed by our payment processor. We do not receive
            or retain your full payment card information. We recommend that you
            carefully review the payment processor's privacy policy before
            making a purchase.
          </span>
        </li>
        <li className="c12 li-bullet-12">
          <span className="c7">
            Our Services and Websites are not intended for minors under the age
            of 18. If a parent or guardian becomes aware that their child under
            18 has provided us with personal information, they may contact us
            and we will make reasonable efforts to delete the child's data
            promptly.
          </span>
        </li>
        <li className="c12 li-bullet-11">
          <span className="c7">
            If you have an account with us or use our Services, you may access,
            update, and delete certain information directly through your
            account.
          </span>
        </li>
        <li className="c12 li-bullet-17">
          <span className="c7">
            You can unsubscribe from receiving future marketing communications
            from us by following the instructions provided in the email,
            responding to our emails with the subject line "Opt Out," or
            modifying your profile settings. Please note that you cannot opt out
            of service-related communications.
          </span>
        </li>
        <li className="c12 li-bullet-9">
          <span className="c7">
            You or your administrator may deactivate your account to discontinue
            using our Services. However, depending on your use of our Services
            and Websites, this may not remove all of your information.
          </span>
        </li>
        <li className="c12 li-bullet-11">
          <span className="c7">
            To learn how to manage browser-based cookie controls, please refer
            to our Cookie Policy.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={10}>
        <li className="c10 li-bullet-8">
          <span className="c0">CHANGES TO OUR PRIVACY POLICY:</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c12 li-bullet-11">
          <span className="c4">
            We reserve the right to modify this Privacy Policy and our Terms
            &amp; Conditions at any time. We will notify you of any changes to
            this Privacy Policy upon their implementation.
          </span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-0" start={11}>
        <li className="c10 li-bullet-15">
          <span className="c0">LAST UPDATED</span>
        </li>
      </ol>
      <ol className="c2 lst-kix_puk3iz2l9na6-1 start" start={1}>
        <li className="c13 c16 li-bullet-11">
          <span className="c7">
            This Privacy Policy was last updated on April 20
          </span>
          <span className="c7 c17">th</span>
          <span className="c4">&nbsp;2023</span>
        </li>
      </ol>
      <p className="c13 c23">
        <span className="c4" />
      </p>
      <div>
        <p className="c22">
          <span className="c15" />
        </p>
        <p className="c11">
          <span className="c15" />
        </p>
      </div>
    </div>
  );
}
